module.exports = __webpack_public_path__ + "img/lock.6cbd609c.svg";